export const extractWistiaIdFromWistiaURL = (url) => {
  if (!url) return null;
  if (url.includes("wistia.com")) {
    return url.substring(url.lastIndexOf("/") + 1, url.length);
  }
  return null;
};
